module.exports = __webpack_public_path__ + "img/membresia_paso4.6b52337f.svg";